import { SortableContainerHOC } from "@common/hocs/dnd";
import classNames from "classnames";
import React from "react";

export interface PillowListProps {
  className?: string;
  children: any;
}
const PillowList = (props: PillowListProps) => (
  <div className={classNames("pillow_list", props.className)}>{props.children}</div>
);
export default PillowList;

export const PillowListSortable = SortableContainerHOC<PillowListProps>(PillowList);
